import { render, staticRenderFns } from "./SimpleMap.vue?vue&type=template&id=0674fbd6&"
import script from "./SimpleMap.vue?vue&type=script&lang=ts&"
export * from "./SimpleMap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports